import React, { useState } from 'react';
import { BoxContainer, FormSection } from '../../../components';
import { TablePagination } from '../../../components/tables';
import BulkDownloadDocumentsInsuredsTable from './BulkDownloadDocumentsInsuredsTable';
import BulkDownloadDocumentsInsuredsFilters from './BulkDownloadDocumentsInsuredsFilters';
import useListDocumentInsureds from '../hooks/useListDocumentInsureds';

export default function BulkDownloadDocumentsInsuredsSelection({ formik, clientId, policyId }) {
  const { activeOnDate, insuredIdsFilteredByDocs: insuredIds } = formik?.values;
  const isClientContext = !!clientId;

  const [insuredsFilter, setInsuredsFilter] = useState({
    clientId: isClientContext ? clientId : null,
    policyId: isClientContext ? null : policyId,
    status: 'ACTIVE',
    ordering: 'LAST_NAME',
    activeOn: activeOnDate,
    ids: insuredIds
  });

  const { insureds, loading, error, paginationProps, loadFirstPage } = useListDocumentInsureds({
    filters: insuredsFilter
  });

  const onChange = filters => {
    setInsuredsFilter({ ...filters });
    loadFirstPage({ ...insuredsFilter, ...filters });
  };

  return (
    <FormSection title="Select Insureds">
      <BulkDownloadDocumentsInsuredsFilters
        defaults={insuredsFilter}
        onChange={onChange}
        filterValue={insuredsFilter}
      />
      <BoxContainer>
        <BulkDownloadDocumentsInsuredsTable formik={formik} insureds={insureds} loading={loading} error={error} />
      </BoxContainer>
      <TablePagination {...paginationProps} loading={loading} />
    </FormSection>
  );
}
